import { DOMAIN_TYPE } from '../constants';

const DOMAIN_NAME = 'realtime';

export const START_SELECT_DAY =
  `${DOMAIN_TYPE}/${DOMAIN_NAME}/START_SELECT_DAY` as const;

export const SET_SELECTED_DAY =
  `${DOMAIN_TYPE}/${DOMAIN_NAME}/SET_SELECTED_DAY` as const;
